import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { designAreaAppliesMask, getCurrentCanvasSize } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { getClientHighlightColor, visualizationModeCheck } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { DefaultDesigner } from '../../../Screens/Configurator/DesignerUI';

const mapStateToProps = (state) => {
  const canvasSize = getCurrentCanvasSize(state);
  const show = canvasSize.width > 0 && canvasSize.height > 0;
  const selectedColor = getClientHighlightColor(state);
  const enableHiding = visualizationModeCheck(state).is3D();
  const hasBorder = !designAreaAppliesMask(state);
  return {
    Component: DefaultDesigner,
    canvasSize,
    show,
    selectedColor,
    hasBorder,
    hideDesigner: enableHiding ? Services.designData.closeDesignAreaEditor : undefined,
  };
};

export default containerConnect(mapStateToProps);
